import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Link } from "react-router-dom";
import {
  buttonBoxStylesCP,
  buttonBoxStylesContainerTelcel,
} from "../../styles/buttonBox";
import {
  SERVICE_ID_TELCEL_POSPAGO,
  SERVICE_ID_TELCEL_PLANES,
  AMIGO_PAGUITOS,
  SERVICE_ID_TELCEL_RECARGA,
  URL_APPLE_STORE,
  URL_PLAY_STORE,
} from "../../constants";
import { getHasDomiciliation } from "../../store/actions/domiciliation";
import ModalCardLoader from "../molecules/ModalCardLoader";
import ModalCustomContainer from "../molecules/ModalCustomContainer";
import ModalCardOk from "../molecules/ModalCardOk";
import { getNavigator, isObjectEmpty } from "../organisms/utils";
import HasDomiciliationModal from "../molecules/HasDomiciliationModal";
import { getMessengerService } from "../../store/actions";
import { executeTaggeo, getPaymentMethods } from "../../store/actions";
import { getPaymentReminder } from "../../store/actions/payReminder";
import * as sdkclaro from "@claropay/claro-pay-sdk-v2";
import enviromentsRules from "../../enviromentsRules";
import { getDomiciliationWindowId } from "../organisms/utils";
import HasFavoriteServices from "../molecules/HasFavoriteServices";
import {
  getAPLoanAccountId,
  getAPLoanReducer,
} from "../../store/selectors/aploanSelectors";
import { getMessage, validateUserAgent } from "../organisms/utils";
import {
  fetchAmigoPaguitosLoanDetails,
  fetchAmigoPaguitosLoanDetailsReset,
} from "../../store/actions/aploan";
import ModalMessagingComposed from "../molecules/ModalMessaging";

export default class ButtonBoxContainer extends Component {
  constructor(props) {
    super(props);
    this.buttonDomiciliationRef = React.createRef();
    this.state = {
      buttonBox: [],
      newRequestDomiciliationService: false,
      isFavoriteServices: false,
      upsellCreate: false,
      getSearchCard: false,
      getUpsellEnd: false,
      countPaymentMethodsCall: 0,
      openModalFailedService: false,
      APModal: {
        show: false,
        flux: undefined,
        code: undefined,
      },
    };
    this.handleOnClickModal = this.handleOnClickModal.bind(this);
  }

  componentDidMount() {
    const { input, isContainerTelcel, getMessengerService } = this.props;
    if (input.cp && !isContainerTelcel) {
      this.setState({ buttonBox: input.cp });
    }
    getMessengerService("PagosProgramados");
    this.assignTagServiceTelcel(this.props.serviceId);
  }

  componentWillReceiveProps(nextProps) {
    console.log("...", nextProps.hasDmResponse, this.props.hasDmResponse);
    if (
      this.props &&
      this.props.serviceId === AMIGO_PAGUITOS &&
      this.props &&
      this.props.accountValue.startsWith("10")
    ) {
      // belongs to AP account
      const claroId =
        this.props &&
        this.props.paymentsStore &&
        this.props.paymentsStore.userInfo &&
        this.props.paymentsStore.userInfo.username;

      const claroidEncrypted =
        this.props &&
        this.props.paymentsStore &&
        this.props.paymentsStore.userInfo &&
        this.props.paymentsStore.userInfo.msisdnEncrypt &&
        this.props.paymentsStore.userInfo.msisdnEncrypt.data;
      const { executeTaggeo } = this.props;

      if (nextProps.hasDmResponse !== this.props.hasDmResponse) {
        if (
          nextProps.hasDmResponse &&
          nextProps.hasDmResponse.data &&
          !nextProps.hasDmResponse.data.domiciliation
        ) {
          this.props.fetchAmigoPaguitosLoanDetails(this.props.accountValue);
        } else {
          // Cuenta con AP domiciliado
          if (nextProps && !nextProps.hasDmError) {
            executeTaggeo({
              eventName: "pay_service_or_tae",
              claroId: claroId,
              msisdn: claroidEncrypted,
              step: "Formulario de pago",
              action: "View alert",
              alert_id: "El número ya se encuentra domiciliado",
              service: this.state.tagServiceId,
            });

            this.setState({
              APModal: {
                show: true,
                flux: "PagosProgramados",
                code: "CP0014",
              },
            });
          }
        }
        // aqui remplazamos con nuestro propio setState para los modales de status
        // si no tiene domiciliacion en este punto, disparamos un nuevo action creator pero ahora para pegarle a una saga que obtenga el credito de AP
        // aca mismo más abajo hacemos algo como if(nextProps.hasAPResponse)
      }
      if (nextProps.loanStatus.loading !== this.props.loanStatus.loading) {
        if (
          nextProps.apAccountId && // this is the error in fact.
          nextProps &&
          nextProps.loanStatus.status
        ) {
          if (nextProps.loanStatus.status === "MORA") {
            // flujo cuenta vigente
            /*        this.setState({
              APModal: {
                show: true,
                flux: "PagosProgramados",
                code: "CP0016",
              },
            }); */
            // this.setState({ newRequestDomiciliationService: true });
            this.props.fetchAmigoPaguitosLoanDetailsReset();
            const url = {
              app: "startEventNoClose",
              to: "openMicroApp",
              parameters: JSON.stringify({
                microAppId: "domiciliacionAmigoPaguitos",
                detail: nextProps.loanStatus.detail,
                dueDate: nextProps.loanStatus.dueDate,
                expirationDate: nextProps.loanStatus.expirationDate,
                maxAmount: nextProps.loanStatus.maxAmount,
                reference: nextProps.loanStatus.reference,
                periodicity: nextProps.loanStatus.periodicity,
                pendingAmount: nextProps.loanStatus.pendingAmount,
                model: nextProps.loanStatus.model,
                brand: nextProps.loanStatus.brand,
                from: "domiciliacionAmigoPaguitos",
              }),
            };

            return sdkclaro.getInstance().openNative(
              JSON.stringify(url),
              () => {},
              () => {},
            );
          } else if (nextProps.loanStatus.status === "CANC") {
            // flujo cuenta con AP liquidado

            executeTaggeo({
              eventName: "pay_service_or_tae",
              claroId: claroId,
              msisdn: claroidEncrypted,
              step: "Formulario de pago",
              action: "View alert",
              alert_id: "Amigo Paguitos liquidado",
              service: this.state.tagServiceId,
            });
            this.setState({
              APModal: {
                show: true,
                flux: "PagosProgramados",
                code: "CP0029",
              },
            });
          } else if (nextProps.loanStatus.status === "DEFI") {
            this.setState({
              APModal: {
                show: true,
                flux: "PagosProgramados",
                code: "CP0031",
              },
            });
          } else if (nextProps.loanStatus.status === "PEND") {
            this.props.fetchAmigoPaguitosLoanDetailsReset();
            const url = {
              app: "startEventNoClose",
              to: "openMicroApp",
              parameters: JSON.stringify({
                microAppId: "domiciliacionAmigoPaguitos",
                detail: nextProps.loanStatus.detail,
                dueDate: nextProps.loanStatus.dueDate,
                expirationDate: nextProps.loanStatus.expirationDate,
                maxAmount: nextProps.loanStatus.maxAmount,
                reference: nextProps.loanStatus.reference,
                periodicity: nextProps.loanStatus.periodicity,
                pendingAmount: nextProps.loanStatus.pendingAmount,
                model: nextProps.loanStatus.model,
                brand: nextProps.loanStatus.brand,
                from: "domiciliacionAmigoPaguitos",
              }),
            };

            return sdkclaro.getInstance().openNative(
              JSON.stringify(url),
              () => {},
              () => {},
            );
          }
        }
      }

      // por aqui debe ir el flujo de cuenta no "vigente" o de forma implícita el servicio de
      // solucionfas lo trae
      if (
        nextProps.loanStatus.err !== "undefined" &&
        nextProps.loanStatus.err !== this.props.loanStatus.err
      ) {
        // flujo Error en la consulta
        // this.props.fetchAmigoPaguitosLoanDetailsReset();
        if (
          nextProps.loanStatus &&
          nextProps.loanStatus.err &&
          nextProps.loanStatus.err.errnro === 13
        ) {
          executeTaggeo({
            eventName: "pay_service_or_tae",
            claroId: claroId,
            msisdn: claroidEncrypted,
            step: "Formulario de pago",
            action: "View alert",
            alert_id: "El número de cuenta no es un Amigo Paguitos",
            service: this.state.tagServiceId,
          });
          this.setState({
            APModal: {
              show: true,
              flux: "PagosProgramados",
              code: "CP0030",
            },
          });
        } else if (nextProps.loanStatus && nextProps.loanStatus.err) {
          executeTaggeo({
            eventName: "pay_service_or_tae",
            claroId: claroId,
            msisdn: claroidEncrypted,
            step: "Formulario de pago",
            action: "View alert",
            alert_id: "Tu solicitud no pudo ser completada",
            service: this.state.tagServiceId,
          });
          this.setState({
            APModal: {
              show: true,
              flux: "PagosProgramados",
              code: "CP0013",
            },
          });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    const {
      isLoadingGetPaymentMethods,
      errorPaymentMethods,
      getMessengerService,
    } = this.props;
    if (this.state.upsellCreate && !this.state.getSearchCard) {
      this.setState({ getSearchCardgetSearchCard: true });
      this.props.getPaymentMethods(this.props.serviceId, false);
      getMessengerService("PagosProgramados");
    }
    if (prevProps.isLoadingGetPaymentMethods && !isLoadingGetPaymentMethods) {
      if (errorPaymentMethods && !this.state.getUpsellEnd) {
        if (this.state.countPaymentMethodsCall < 2) {
          this.setState({
            countPaymentMethodsCall: this.state.countPaymentMethodsCall + 1,
          });
          this.props.getPaymentMethods(this.props.serviceId, false);
        } else {
          this.setState({ openModalFailedService: true });
          this.setState({ getUpsellEnd: true });
        }
      } else {
        setTimeout(() => {
          if (
            this.buttonDomiciliationRef.current &&
            this.state.getSearchCard &&
            !this.state.getUpsellEnd
          ) {
            sessionStorage.setItem("domiciliationUpsell", true);
            this.buttonDomiciliationRef.current.click();
            this.setState({ getUpsellEnd: true });
          }
        }, 500);
      }
    }
  }

  assignTagServiceTelcel(serviceId) {
    let newTagServiceId;

    switch (true) {
      case serviceId === SERVICE_ID_TELCEL_PLANES:
        newTagServiceId = "telcelAmigoSinLimitePs";
        break;
      case serviceId === SERVICE_ID_TELCEL_POSPAGO:
        newTagServiceId = "TelcelPospagoPS";
        break;
      case serviceId === AMIGO_PAGUITOS:
        newTagServiceId = "amigopaguitos";
        break;
      case serviceId === SERVICE_ID_TELCEL_RECARGA:
        newTagServiceId = "serviciopagotelcel";
        break;
      default:
        newTagServiceId = this.props.tagServiceId;
    }

    if (this.state.tagServiceId !== newTagServiceId) {
      this.setState({ tagServiceId: newTagServiceId });
    }
  }

  getStyles() {
    return this.props.isContainerTelcel
      ? buttonBoxStylesContainerTelcel
      : buttonBoxStylesCP;
  }

  handleUpsellN2 = (paramsKey) => {
    const params = {
      requestCode: getDomiciliationWindowId(paramsKey),
      serviceName: this.state.tagServiceId,
    };
    const url = {
      app: "startEventNoClose",
      to: "openUpSellN2",
      parameters: JSON.stringify(params),
    };
    sdkclaro.getInstance().openNative(
      JSON.stringify(url),
      () => {},
      () => {},
    );
  };

  handleModalUpdate = () => {
    this.setState({
      openModalUpdateApp: true,
      modalUpdateAppInformation: getMessage(this.props.messages, "CP0021"),
    });
  };

  handleOnclick = (e, type) => {
    const { tagServiceId } = this.state;
    const {
      handleInputButtonFunction,
      getHasDomiciliation,
      accountValue,
      serviceId,
      executeTaggeo,
      canManageFavorites,
      isClaroPartner,
      canUpsellN2,
      errorPaymentMethods,
      paymentMethods,
    } = this.props;
    const hasN2 =
      typeof paymentMethods.hasN2 !== "undefined" ? paymentMethods.hasN2 : true;
    const hasNIP =
      typeof paymentMethods.hasNIP !== "undefined"
        ? paymentMethods.hasNIP
        : true;
    if (type === "escanear") {
      handleInputButtonFunction(e, "ocr");
    }
    if (type === "domiciliar") {
      if (errorPaymentMethods) {
        this.setState({ openModalFailedService: true });
      } else if (!hasN2) {
        if (!canUpsellN2) {
          this.handleModalUpdate();
        } else {
          this.handleUpsellN2("NOT_N2");
        }
      } else if (hasN2 && !hasNIP) {
        if (!canUpsellN2) {
          this.handleModalUpdate();
        } else {
          this.handleUpsellN2("N2_NOT_NIP");
        }
      } else {
        getHasDomiciliation(accountValue, serviceId);
        this.setState({ newRequestDomiciliationService: true });
        executeTaggeo({
          action: "Click Domiciliar",
          step: "Formulario de pago",
          service: tagServiceId,
        });
      }
    }
    if (type === "favoritos" && canManageFavorites && !isClaroPartner) {
      this.setState({ isFavoriteServices: true });
      executeTaggeo({
        action: "Click Guardados",
        step: "Formulario de pago",
        service: tagServiceId,
      });
    }
  };
  closeModalFavoriteServices = () => {
    this.setState({ isFavoriteServices: false });
  };

  onclickCloseModal = () => {
    this.setState({ openModalFailedService: false });
  };

  handleOnClickModal() {
    this.setState({
      APModal: {
        show: false,
        flux: undefined,
        code: undefined,
      },
    });
  }

  handleOnClickModalUpdateApp = (e) => {
    const { innerText } = e.target;
    if (innerText == "Hacerlo en otro momento") {
      this.setState({
        openModalUpdateApp: false,
      });
    }
    if (innerText == "Actualizar") {
      const linkInformation = JSON.stringify({
        app: "https",
        url:
          validateUserAgent() === "android" ? URL_PLAY_STORE : URL_APPLE_STORE,
      });
      sdkclaro.getInstance().openNative(
        linkInformation,
        () => {},
        () => {},
      );
    }
  };
  render() {
    const styles = this.getStyles();
    const {
      buttonBox,
      isFavoriteServices,
      tagServiceId,
      newRequestDomiciliationService,
      openModalUpdateApp,
      modalUpdateAppInformation,
      openModalFailedService,
    } = this.state;
    const {
      amount,
      accountValueValidLength,
      accountValue,
      paymentMethods,
      hasDmResponse,
      isLoadingServiceDomiciliation,
      hasDmError,
      history,
      goToDomiciliationForm,
      amountTelcelPospago,
      canManageFavorites,
      isContainerTelcel,
      handleSetFavValue,
      isClaroPartner,
      paymentsStore,
      serviceId,
      executeTaggeo
    } = this.props;
    return (
      <>
        <div style={styles.wrapper}>
          {buttonBox.map((button, index) => {
            let active = true;
            if (button.id === "mas_paquetes_pospago") {
              return;
            }
            if (button.id === "agenda") {
              const agendaConfig = button;
              console.log("renderear agenda!", agendaConfig);

              return (
                agendaConfig &&
                agendaConfig.src &&
                agendaConfig.text && (
                  <Link
                    style={
                      active
                        ? {
                            ...styles.button,
                            paddingLeft: "6px",
                            paddingRight: "6px",
                          }
                        : styles.buttonDisabled
                    }
                    disabled={!active}
                    key={index}
                    to={{
                      pathname: "/contacts",
                      state: {
                        serviceId: serviceId,
                        isContainerTelcel: isContainerTelcel,
                        isClaroPartner: isClaroPartner,
                      },
                    }}
                  >
                    <img src={agendaConfig.src} style={styles.buttonIcon} />
                    {agendaConfig && agendaConfig.text && (
                      <span
                        style={{
                          ...styles.buttonText,
                          fontFamily: "Amx-Regular",
                          color: "#474747",
                          fontSize: "12px",
                        }}
                      >
                        {agendaConfig.text}
                      </span>
                    )}
                  </Link>
                )
              );
            }
            if (button.id === "domiciliar") {
              if (
                !goToDomiciliationForm &&
                (parseFloat(amount) <= 0 ||
                  !paymentMethods ||
                  !paymentMethods.hasN2 ||
                  !accountValueValidLength ||
                  accountValueValidLength !== accountValue.length)
              ) {
                active = false;
              }
              if (
                accountValue.length === 10 &&
                accountValue.startsWith("10") &&
                this.props.serviceId === AMIGO_PAGUITOS &&
                this.props.isContainerTelcel === false
              ) {
                active = true;
              }
              setTimeout(() => {
                if (
                  !isObjectEmpty(hasDmResponse) &&
                  !hasDmResponse.data.domiciliation &&
                  goToDomiciliationForm &&
                  goToDomiciliationForm !== this.state.tagServiceId &&
                  this.buttonDomiciliationRef.current &&
                  this.props.serviceId !== AMIGO_PAGUITOS
                ) {
                  this.buttonDomiciliationRef.current.click();
                }
              }, 500);
              setTimeout(() => {
                if (
                  goToDomiciliationForm &&
                  goToDomiciliationForm === this.state.tagServiceId &&
                  this.buttonDomiciliationRef.current &&
                  !this.state.upsellCreate &&
                  sessionStorage.getItem("domiciliationUpsell") !== "true"
                ) {
                  this.setState({ upsellCreate: true });
                }
              }, 500);
            }
            if (button.id === "cambiar") {
              return (
                <button
                  style={styles.button}
                  disabled={!active}
                  key={index}
                  onClick={() => {
                    const url = {
                      app: "startEventNoClose",
                      to: "openMicroApp",
                      parameters: JSON.stringify({
                        microAppId: "telcelAmigoSinLimitePs",
                      }),
                    };
                    setTimeout(() => {
                      sdkclaro.getInstance().openNative(
                        JSON.stringify(url),
                        () => {},
                        () => {},
                      );
                    }, 1000);
                  }}
                >
                  <span style={styles.buttonText}>{button.text}</span>
                </button>
              );
            }
            console.log(
              "---disabled?---",
              button.id === "domiciliar" &&
                enviromentsRules(paymentsStore, "showButtonDomiciliation") &&
                this.props.isContainerTelcel === false,
              enviromentsRules(paymentsStore, "showButtonDomiciliation"),
              this.props.isContainerTelcel,
            );

            return (
              <>
                {(button.id === "favoritos" &&
                  enviromentsRules(paymentsStore, "showButtonFavorites")) ||
                (button.id === "domiciliar" &&
                  enviromentsRules(paymentsStore, "showButtonDomiciliation") &&
                  this.props.isContainerTelcel === false) ||
                (button.id === "escanear" &&
                  enviromentsRules(paymentsStore, "showButtonScanner")) ? (
                  <button
                    style={active ? styles.button : styles.buttonDisabled}
                    disabled={!active}
                    key={index}
                    onClick={(e) => {
                      if (
                        button.id === "domiciliar" &&
                        this.props.serviceId === AMIGO_PAGUITOS
                      ) {
                        const claroId =
                          this.props &&
                          this.props.paymentsStore &&
                          this.props.paymentsStore.userInfo &&
                          this.props.paymentsStore.userInfo.username;

                        const claroidEncrypted =
                          this.props &&
                          this.props.paymentsStore &&
                          this.props.paymentsStore.userInfo &&
                          this.props.paymentsStore.userInfo.msisdnEncrypt &&
                          this.props.paymentsStore.userInfo.msisdnEncrypt.data;
                        executeTaggeo({
                          eventName: "pay_service_or_tae",
                          msisdn: claroidEncrypted,
                          claroId: claroId,
                          action: "Click Domiciliar",
                          step: "Formulario de pago",
                          service: this.state.tagServiceId,
                        });

                        console.warn("flujo domiciliar desde AP");
                        this.props.getHasDomiciliation(
                          this.props.accountValue,
                          this.props.serviceId,
                        );
                      } else {
                        this.handleOnclick(e, button.id);
                      }
                    }}
                    ref={
                      button.id === "domiciliar"
                        ? this.buttonDomiciliationRef
                        : ""
                    }
                  >
                    <img
                      src={active ? button.iconEnabled : button.iconDisabled}
                      style={styles.buttonIcon}
                    />
                    <span style={styles.buttonText}>{button.text}</span>
                  </button>
                ) : (
                  <></>
                )}
              </>
            );
          })}
        </div>
        <ModalCardLoader isOpen={isLoadingServiceDomiciliation} />
        <ModalMessagingComposed
          showModalMessaging={this.state.APModal.show}
          currentFlux={this.state.APModal.flux}
          currentCode={this.state.APModal.code}
          handleOnClickModal={this.handleOnClickModal}
        />

        {(newRequestDomiciliationService &&
          !isLoadingServiceDomiciliation &&
          !isObjectEmpty(hasDmResponse)) ||
        hasDmError ? (
          <div
            style={{
              position: "fixed",
              top: "0px",
              left: "0px",
              zIndex: 99,
              width: "100%",
            }}
          >
            <HasDomiciliationModal
              hasDmResponse={hasDmResponse}
              hasDmError={hasDmError}
              history={history}
              accountValue={accountValue}
              amount={amount}
              tagServiceId={tagServiceId}
              serviceId={this.props.serviceId}
            />
          </div>
        ) : (
          <></>
        )}

        {isFavoriteServices && (
          <HasFavoriteServices
            configImgService={this.props.configImgService}
            isFavoriteServices={isFavoriteServices}
            isContainerTelcel={isContainerTelcel}
            closeModalFavoriteServices={this.closeModalFavoriteServices}
            serviceId={this.props.serviceId}
            tagServiceId={tagServiceId}
            handleSetFavValue={handleSetFavValue}
          />
        )}
        {openModalUpdateApp && modalUpdateAppInformation ? (
          <ModalCustomContainer
            isOpen={openModalUpdateApp}
            backgroundColor={"rgba(0, 0, 0, 0.65)"}
          >
            <ModalCardOk
              isOpen={openModalUpdateApp}
              srcImage={modalUpdateAppInformation.data.icon}
              text={modalUpdateAppInformation.data.subject}
              textdetail={modalUpdateAppInformation.data.message}
              buttontext={modalUpdateAppInformation.data.buttons[0]}
              backgroundColorButton={isContainerTelcel ? "#7B1FA2" : undefined}
              colorButton={isContainerTelcel ? "#ffffff" : undefined}
              fontFamilyButton="AMX-Bold"
              fontSizeButton={isContainerTelcel ? "16px" : undefined}
              widthButton={isContainerTelcel ? "95%" : undefined}
              heightButton={isContainerTelcel ? "43px" : undefined}
              marginButton={isContainerTelcel ? "0px 0px 25px 0px" : undefined}
              paddingButton={
                isContainerTelcel ? "2px 10px 0px 10px" : undefined
              }
              onclickModal={this.handleOnClickModalUpdateApp}
              fontSizeTitle={!isContainerTelcel ? "18px" : "20px"}
              fontFamilyTitle="AMX-Bold"
              textLink={modalUpdateAppInformation.data.buttons[1]}
              fontFamilyLinkButton="AMX-Bold"
              textSizeLinkButton={isContainerTelcel ? "16px" : undefined}
              textColorLinkButton={isContainerTelcel ? "#1470D1" : undefined}
            />
          </ModalCustomContainer>
        ) : openModalFailedService ? (
          <ModalCustomContainer
            isOpen={openModalFailedService}
            backgroundColor={"rgba(0, 0, 0, 0.65)"}
          >
            <ModalCardOk
              isOpen={openModalFailedService}
              srcImage="data:image/png;base64,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"
              text="¡Uy, algo pasó!"
              buttontext="Ok"
              textdetail="Por el momento este servicio no está disponible. Por favor, intenta más tarde."
              onclickModal={this.onclickCloseModal}
              fontFamilyTextdetail={
                isContainerTelcel ? "AMX-Regular" : undefined
              }
              fontSizeDetail={isContainerTelcel ? "16px" : "12px"}
              fontFamilyTitle={isContainerTelcel ? "AMX-Bold" : undefined}
            />
          </ModalCustomContainer>
        ) : (
          <></>
        )}
      </>
    );
  }
}

function mapStateToProps(state) {
  const {
    domiciliationReducer: {
      hasDomiciliationServiceResponseError,
      hasDomiciliationServiceResponseSuccess,
      isLoadingServiceDomiciliation,
      goToDomiciliationForm,
      canUpsellN2,
    },
    payments: {
      paymentMethods,
      messages,
      amountTelcelPospago,
      PAYMENT_SERVICE_CONF,
      isLoadingGetPaymentMethods,
      errorPaymentMethods,
    },
  } = state;
  return {
    canUpsellN2,
    messages,
    errorPaymentMethods: errorPaymentMethods,
    paymentMethods: paymentMethods,
    hasDmError: hasDomiciliationServiceResponseError,
    isLoadingServiceDomiciliation,
    hasDmResponse: hasDomiciliationServiceResponseSuccess,
    canManageFavorites: state.payments.canManageFavorites,
    goToDomiciliationForm,
    amountTelcelPospago,
    isLoadingGetPaymentMethods: isLoadingGetPaymentMethods,
    isClaroPartner: PAYMENT_SERVICE_CONF.isClaroPartner,
    paymentsStore: state.payments,
    apAccountId: getAPLoanAccountId(state),
    loanStatus: getAPLoanReducer(state),
    isContainerTelcel: state.payments.isContainerTelcel,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getHasDomiciliation,
      getPaymentMethods,
      getMessengerService,
      getPaymentReminder,
      executeTaggeo,
      fetchAmigoPaguitosLoanDetails,
      fetchAmigoPaguitosLoanDetailsReset,
    },
    dispatch,
  );
}

ButtonBoxContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ButtonBoxContainer);
